var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.1,77.9v15.5h-1.4v-2.2c-0.9,1.5-2.4,2.3-4.2,2.3c-3.1,0-5.5-2.3-5.5-5.6c0-3.3,2.3-5.6,5.5-5.6 c1.8,0,3.3,0.8,4.2,2.2v-6.6H43.1z M41.7,87.9c0-2.6-1.8-4.3-4.1-4.3c-2.3,0-4.1,1.7-4.1,4.3c0,2.6,1.8,4.3,4.1,4.3 C39.9,92.2,41.7,90.5,41.7,87.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.8,88.4h-9.2c0.2,2.3,1.9,3.8,4.3,3.8c1.3,0,2.5-0.5,3.4-1.4l0.8,1c-1,1.2-2.5,1.8-4.2,1.8 c-3.4,0-5.8-2.3-5.8-5.6c0-3.3,2.3-5.6,5.4-5.6c3.1,0,5.3,2.3,5.3,5.6C56.9,88.1,56.8,88.2,56.8,88.4z M47.7,87.3h7.8 c-0.2-2.2-1.8-3.7-3.9-3.7C49.4,83.6,47.8,85.1,47.7,87.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68.9,82.4l-4.9,11h-1.5l-4.9-11h1.5l4.1,9.4l4.2-9.4H68.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.4,50.1c0,1.9-1.5,3.4-3.4,3.4c-1.9,0-3.4-1.5-3.4-3.4s1.5-3.4,3.4-3.4C51.9,46.7,53.4,48.2,53.4,50.1z  M71.6,52V8.9c0-4.3-3.5-7.8-7.8-7.8H36.1c-4.3,0-7.8,3.5-7.8,7.8V52c0,4.3,3.5,7.8,7.8,7.8h27.7C68.1,59.8,71.6,56.3,71.6,52z  M63.9,4.4c2.5,0,4.5,2,4.5,4.5V52c0,2.5-2,4.5-4.5,4.5H36.1c-2.5,0-4.5-2-4.5-4.5V8.9c0-2.5,2-4.5,4.5-4.5H63.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDev);
export default __webpack_public_path__ + "static/media/dev.937f22779f35b316de71582f4a1105b4.svg";
export { ForwardRef as ReactComponent };